/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Derived supervisor presence for a student (API mirror of service enum).
 */
export type OralExamSupervisorStatus = (typeof OralExamSupervisorStatus)[keyof typeof OralExamSupervisorStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamSupervisorStatus = {
  here_with_you: 'here_with_you',
  watching: 'watching',
  engaged: 'engaged',
} as const;
